import { TextShow } from 'Utils/Helpers/TextShow';
import * as icons from 'react-bootstrap-icons';
import Header from '../Header';
import ManageStatuses from './manage';
import ListStatuses from './list';

const title = 'وضعیت‌ها';

export default function SetStatuses() {
  return (
    <>
      <Header title={title} justText />
      <div className=''>
        <TextShow
          title={"تنظیم وضعیت‌های قابل انجام برای هر نوبت"}
          icon={<icons.Back size={18} />}
          justText
          className={'no-hide text-muted'}
        />
        <div className='setting-app-types'>
          <ManageStatuses />
          <ListStatuses />
        </div>
      </div>
    </>
  );
}